<template lang="pug">
stock-detail( path-name="FutureChanceHistory" )
</template>

<script>
import StockDetail from '@components/stock_detail.vue'
export default {
  components: {
    StockDetail
  }
}
</script>
